import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, Users } from 'lucide-react';
import { mockData, iconMap } from '../mock';

const ServicesSection = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);
  const categoryRefs = useRef({});

  const scrollToCategory = (slug) => {
    setActiveCategory(slug);
    const el = categoryRefs.current[slug];
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="services" className="services-section" data-testid="services-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Comprehensive financial solutions tailored to your needs</p>
        </div>

        {/* Dropdown Category Navigation */}
        <div className="services-dropdown-nav" data-testid="services-dropdown">
          {mockData.serviceCategories.map((category) => (
            <button
              key={category.slug}
              className={`services-dropdown-btn ${activeCategory === category.slug ? 'active' : ''}`}
              data-testid={`dropdown-${category.slug}`}
              onClick={() => scrollToCategory(category.slug)}
            >
              {category.title}
            </button>
          ))}
        </div>

        {mockData.serviceCategories.map((category, idx) => (
          <div
            key={idx}
            ref={(el) => (categoryRefs.current[category.slug] = el)}
            className="catalog-category"
            style={{ marginBottom: '48px', scrollMarginTop: '160px' }}
          >
            <h3 className="catalog-category-title">{category.title}</h3>
            <div className="catalog-cards-grid">
              {category.services.map((service, sIdx) => {
                const IconComponent = iconMap[service.icon] || Star;
                return (
                  <div
                    key={sIdx}
                    className="catalog-card"
                    data-testid={`service-card-${service.slug}`}
                    onClick={() => navigate(`/get-started/${service.slug}`)}
                  >
                    <div className="catalog-card-icon">
                      <IconComponent size={28} />
                    </div>
                    <p className="catalog-card-name">{service.name}</p>
                    <div className="catalog-card-meta">
                      <span className="catalog-card-rating">
                        {service.rating} <Star size={12} fill="#00A86B" stroke="#00A86B" />
                      </span>
                      <span className="catalog-card-users">
                        {service.users} <Users size={12} />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
